import CompanyInfo from './CompanyInfo'
import Contact from './Contact'

const ContactUsPage = () => {
    return (
        <>
            {/* <TitleBarMin title="Contact Us"></TitleBarMin> */}


            <div className='mb-4'>
                {/* For the gap below nav */}
                <p>For the gap below nav</p>
            </div>
            <Contact />
            {/* <CompanyInfo /> */}
            

        </>
    )
}

export default ContactUsPage